import React, { useState } from 'react';
import about1 from '../../assets/About_content.avif';
import { FaHotel, FaUsers, FaUsersCog } from 'react-icons/fa';
import BookNowModal from '../common/BookNowModal';

const AboutSection = () => {
  // Move useState inside the component
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  return (
    <div className='py-6 md:py-10'>
      <div className='container mx-auto px-4 lg:px-16'>
        <div className='grid items-center gap-8 lg:grid-cols-2'>
          {/* Left Image */}
          <div className='flex justify-center lg:justify-start'>
            <img
              src={about1}
              alt='About'
              className='w-full object-cover'
            />
          </div>

          {/* Right Content */}
          <div>
            <h1 className='mont mb-4 text-center text-2xl font-bold md:text-start md:text-4xl'>
              About Bluelagoon Travels
            </h1>
            <p className='mb-6 text-justify leading-relaxed text-gray-700'>
              At BlueLagoon Travels, we believe that travel is not just about visiting new
              places—it’s about creating unforgettable experiences and memories. With over 5 years
              in the industry, we have been dedicated to crafting personalized travel journeys that
              bring your dreams to life, whether it’s a domestic getaway or an international
              adventure.
            </p>
            <p className='mb-6 text-justify leading-relaxed text-gray-700'>
              Our services span across a wide range of holiday packages, hotel bookings, flights and
              customized itineraries that cater to every type of traveller. From serene beach
              escapes to vibrant city tours, we ensure that every trip is designed with the perfect
              balance of relaxation, exploration, and adventure.
            </p>
            <p className='mb-6 text-justify leading-relaxed text-gray-700'>
              At BlueLagoon Travels, our mission is simple: to make travel easy, enjoyable, and
              accessible for everyone. Our expert team takes pride in offering seamless planning,
              insider knowledge, and exceptional customer service, ensuring you have the best
              experience from start to finish.
            </p>
            <p className='mb-6 text-justify leading-relaxed text-gray-700'>
              Let us be your trusted travel partner, and together, let’s create memories that will
              last a lifetime.
            </p>

            <button
              onClick={handleOpen}
              className='relative inline-flex h-[34px] w-[140px] items-center justify-center rounded-[6px] bg-gradient-to-r from-[#495BFF] to-[#55E6A5] p-[1px] transition-all duration-500 hover:from-[#55E6A5] hover:to-[#495BFF] sm:h-[40px] sm:w-[170px] md:h-[46px] md:w-[200px]'
            >
              <span className='flex h-full w-full items-center justify-center rounded-lg bg-transparent text-[13px] font-bold leading-tight text-white sm:text-[15px] md:text-[16px]'>
                Start to Book
              </span>
            </button>

            <BookNowModal
              open={modalOpen}
              onClose={handleClose}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
